var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"json-viewer"},[_c('JsonNode',{attrs:{"data":_vm.jsonData,"depth":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }